import React, { Component } from "react";
import Form from 'react-bootstrap/Form';

class Search extends Component {
    render() {
        return (
            <div className="input-group p-3">
                <div className="col-md-3">
                    <Form.Select
                        id={this.props.name + "-school-select"}
                        variant="primary"
                        aria-label="Program Selection"
                        className="col-md-3"
                        onChange={this.props.onSchoolChanged}>
                        <option value="ALL">All Schools</option>
                        <option value="BHT">BHT - Business, Hospitality, &amp; Technology</option>
                        <option value="ED">ED - Education</option>
                        <option value="HWPS">HWPS - Health, Wellness &amp; Public Safety</option>
                        <option value="LA">LA - Liberal Arts</option>
                        <option value="MSE">MSE - Math, Science &amp; Engineering</option>
                        <option value="NPS">NPS - Nursing and Patient Support</option>
                        <option value="STA">STA - Skilled Trades &amp; Arts</option>
                    </Form.Select>
                </div>
                &nbsp;
                <input
                    type="text"
                    className="form-control"
                    name="this.props.name"
                    placeholder="Filter departments"
                    onChange={this.props.onFilterChanged}
                    />
            </div>
        )
    }
}

export default Search;